import Vue from 'vue'

function convertAbreviationsToMap(raw: any): Record<string, string> {
  try {
    let parsed = raw
    if (typeof raw === 'string') {
      parsed = JSON.parse(raw)
    }

    if (Array.isArray(parsed)) {
      const map: Record<string, string> = {}
      parsed.forEach((entry: any) => {
        if (entry && typeof entry.label === 'string') {
          map[entry.label] = entry.value ?? ''
        }
      })
      return map
    }

    if (parsed && typeof parsed === 'object') {
      return parsed as Record<string, string>
    }
  } catch (e) {
    // fallthrough
  }
  return {}
}

export default Vue.extend({
  data() {
    return {
      abbreviationMap: {} as Record<string, string>,
    }
  },
  mounted() {
    // try load on mount
    try {
      const cfg = (this as any).user?.client?.config ?? {}
      const raw = cfg.abreviations
      if (raw) {
        ;(this as any).abbreviationMap = convertAbreviationsToMap(raw)
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Impossible de parser client.config.abreviations', e)
    }
  },
  watch: {
    user(newVal: any) {
      try {
        const cfg = newVal?.client?.config ?? {}
        const raw = cfg.abreviations
        if (raw) {
          ;(this as any).abbreviationMap = convertAbreviationsToMap(raw)
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Impossible de parser client.config.abreviations', e)
      }
    },
  },
  methods: {
    onDescriptionInput(value: string | null) {
      if ((this as any).itemData) {
        ;(this as any).itemData.description = this.replaceAbbreviations(value)
      }
    },

    replaceAbbreviations(text: string | null): string | null {
      if (!text) return text

      const parts = text.split(/(\s+|[^A-Za-z0-9À-ÖØ-öø-ÿ]+)/)

      const mapLower: Record<string, string> = {}
      Object.keys((this as any).abbreviationMap || {}).forEach((k) => {
        mapLower[k.toLowerCase()] = (this as any).abbreviationMap[k]
      })

      for (let i = 0; i < parts.length; i++) {
        const token = parts[i]
        if (!token) continue

        // We only replace when the token is followed by a whitespace (user pressed space)
        const nextPart = parts[i + 1]
        const followedBySpace = typeof nextPart === 'string' && /^\s+$/.test(nextPart)

        if (/^[A-Za-z0-9À-ÖØ-öø-ÿ.-]+$/.test(token) && followedBySpace) {
          const key = token.toLowerCase()

          if (mapLower[key]) {
            parts[i] = this.matchCase(token, mapLower[key])
            continue
          }

          const keyNoDots = key.replace(/\.+$/g, '')
          if (mapLower[keyNoDots]) {
            const trailing = token.match(/\.+$/)?.[0] ?? ''
            parts[i] = this.matchCase(token, mapLower[keyNoDots]) + trailing
            continue
          }
        }
      }

      return parts.join('')
    },

    matchCase(orig: string, full: string): string {
      if (!orig) return full
      const first = orig.charAt(0)
      if (first === first.toUpperCase()) {
        return full.charAt(0).toUpperCase() + full.slice(1)
      }
      return full
    },
  },
})
